import { toHtml, absolutize } from "../lib/richText";

/** Read-only view of formatted handout text. The server stores it sanitized. */
export function RichText({ html, className = "", testId }) {
  return <div data-testid={testId} className={`cocoa-prose ${className}`} dangerouslySetInnerHTML={{ __html: absolutize(toHtml(html)) }} />;
}
